import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        ids: '',
        title: '',
        context: ''
      },
      reqLoading: false,
      rules: {
        title: [{
          required: true,
          message: "请填写",
          trigger: "blur"
        }],
        context: [{
          required: true,
          message: "请填写",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formData.ids = data;
                _this.formData.title = '';
                _this.formData.context = '';
                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onEditorChange: function onEditorChange(e) {
      this.formData.context = e;
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this2.reqLoading = true;

          _this2.$api.sendNotificationToParentUser(_this2.formData).then(function (res) {
            if (res.code == 200) {
              _this2.reqLoading = false;

              _this2.$message.success('操作成功'); // this.$emit('change')


              _this2.dialogFormVisible = false;
            } else {
              _this2.reqLoading = false;

              _this2.$message.error(res.msg);
            }
          }).catch(function (error) {
            _this2.reqLoading = false;
          });
        }
      });
    }
  }
};